// extracted by mini-css-extract-plugin
module.exports =  {"alert":"FPb7Xv4nmgNrxvDU1nZY","campaignSummary":"eer0CAH1dgve42ZLGYbd"};